import { render, staticRenderFns } from "./CatalogItemCard.vue?vue&type=template&id=5e2267dd&scoped=true"
import script from "./CatalogItemCard.vue?vue&type=script&lang=js"
export * from "./CatalogItemCard.vue?vue&type=script&lang=js"
import style0 from "./CatalogItemCard.vue?vue&type=style&index=0&id=5e2267dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2267dd",
  null
  
)

export default component.exports